import { createStyles, makeStyles } from '@material-ui/core';
import { DRAWER_WIDTH } from '../services/constants';

const useStyles = makeStyles((theme) =>
    createStyles({
        cardsContainer: {
            padding: theme.spacing(2),
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap'
        },
        main: {
            wordBreak: 'break-word',
            padding: theme.spacing(6),
            width: `calc(100% - ${DRAWER_WIDTH}px)`,
            [theme.breakpoints.down('sm')]: {
                padding: 0,
                width: `auto`
            }
            // [theme.breakpoints.up('sm')]: {
            //     width: `calc(100% - ${DRAWER_WIDTH}px)`
            // }
        },
        title: {},
        drawerPaper: {
            width: DRAWER_WIDTH
        },
        drawer: {
            backgroundColor: '#000',
            [theme.breakpoints.up('sm')]: {
                width: DRAWER_WIDTH
            }
        },
        toolbar: theme.mixins.toolbar,
        list: {
            color: '#FFF'
        },
        orederlistLink: {
            color: theme.palette.secondary.dark
        },
        marginLeft: { marginLeft: 16 },
        addressText: { color: '#FFF', marginLeft: 8 },
        fakeHeight: { height: 150 }
    })
);

export default useStyles;
